import ReservationDetails from './ReservationDetails';

export default ReservationDetails;
